import { CompanyType, CompanyTypeInformation } from '../../features/main/types';

export type EnvironmentType = 'development' | 'staging' | 'production';
export const ENVIRONMENT_DEVELOPMENT: EnvironmentType = 'development';

// Payment statuses
export const PAYMENT_STATUS_PROCESSING = 'processing';
export const PAYMENT_STATUS_EXPIRED = 'expired';
export const PAYMENT_STATUS_CANCELED = 'canceled';
export const PAYMENT_STATUS_FAILED = 'failed';
export const PAYMENT_STATUS_PAID = 'paid';
export const PAYMENT_STATUS_SUCCEEDED = 'succeeded';
export const PAYMENT_STATUS_REQUIRES_ACTION = 'requires_action';
export const PAYMENT_STATUS_REQUIRES_PAYMENT_METHOD = 'requires_payment_method';

// URL & Routes
export const FRONT_END_FALLBACK_URL = 'https://app.companio.co';

// Auth
export const AUTH_TOKEN_KEY = 'registration_auth_token';

// Toasts
export const TOAST_AUTO_CLOSE_DURATION = 5000;

// Google Ads
export const GOOGLE_CONVERSION_TAG_STEP_1 = 'Y9eBCL2py7IDEIKbytoB';
export const GOOGLE_CONVERSION_TAG_STEP_2 = 'aNl2CL-dzLIDEIKbytoB';
export const GOOGLE_CONVERSION_TAG_STEP_3 = 'lVBGCLqGlbIDEIKbytoB';
export const GOOGLE_CONVERSION_TAG_STEP_4 = 'LiQdCKfgzbIDEIKbytoB';
export const GOOGLE_CONVERSION_ID = 'AW-458395010';
export const GOOGLE_CONVERSION_ACTION_PURCHASE = 'purchase';

// LinkedIn Ads
export const LINKEDIN_CONVERSION_TAG_STEP_1 = 15326818;
export const LINKEDIN_CONVERSION_TAG_STEP_2 = 15326826;
export const LINKEDIN_CONVERSION_TAG_STEP_3 = 15326834;
export const LINKEDIN_CONVERSION_TAG_STEP_4 = 15326842;

// Endpoints
export const API_ENDPOINT_REGISTRATIONS = '/registrations';
export const API_ENDPOINT_PAYMENTS = '/payments';
export const API_ENDPOINT_VERIFY = '/verify';
export const API_ENDPOINT_SETUP_INTENT = '/setup_intent';
export const API_ENDPOINT_RESTART = '/restart';
export const API_ENDPOINT_THANK_YOU = '/thank_you';
export const API_ENDPOINT_STATUS = '/status';

// Stripe
export const STRIPE_INTENT_PAYMENT_PREFIX = 'seti';

// Plans
export const PLAN_PRO: CompanyType = 'remote';
export const PLAN_PREMIUM: CompanyType = 'crypto';
// export const PLAN_ULTRA: CompanyType = 'ultra';

export const PLAN_OPTIONS: Omit<Record<CompanyType, CompanyTypeInformation>, 'virtual'> = {
  [PLAN_PRO]: {
    title: 'plan_pro',
    price: 89,
    description: 'plan_pro_description',
    benefits: [
      'pro_benefits_1',
      'pro_benefits_2',
      'pro_benefits_3',
      'pro_benefits_4',
      'pro_benefits_5',
      'pro_benefits_6',
      'pro_benefits_7',
      'pro_benefits_8',
      'pro_benefits_9',
      'pro_benefits_10'
    ]
  },
  [PLAN_PREMIUM]: {
    title: 'plan_premium',
    price: 199,
    description: 'plan_premium_description',
    benefits: [
      'premium_benefits_1',
      'premium_benefits_2',
      'premium_benefits_3',
      'premium_benefits_4',
      'premium_benefits_5',
      'premium_benefits_6',
      'premium_benefits_7',
      'premium_benefits_8',
      'premium_benefits_9',
      'premium_benefits_10',
      'premium_benefits_11',
      'premium_benefits_12',
      'premium_benefits_13'
    ]
  }
  // [PLAN_ULTRA]: {
  //   title: 'plan_ultra',
  //   price: 299,
  //   description: 'plan_ultra_description',
  //   benefits: [
  //     'ultra_benefits_1',
  //     'ultra_benefits_2',
  //     'ultra_benefits_3',
  //     'ultra_benefits_4',
  //     'ultra_benefits_5',
  //     'ultra_benefits_6',
  //     'ultra_benefits_7',
  //     'ultra_benefits_8'
  //   ]
  // }
};

export const DEFAULT_PHONE_COUNTRY_CODE = '+372';

export const LOCALE_OPTIONS: Record<string, string> = { en: 'English', es: 'Español' };
export const SUPPORTED_LOCALES = Object.keys(LOCALE_OPTIONS);
export const DEFAULT_LOCALE = 'en';
